/**
 * @todo Удалить файл с экспериментом
 * @description Данный функционал появился в задаче CD-125416, будет удалён в задаче CD-125446
 */

import { createSelector } from 'reselect';

import { abUseExperimentsSelector, getIsAbUseExperimentsActiveFactory } from '../abUseExperiments';

export const COMMERCIAL_TC_BC_BLOCK_EXPERIMENT = 'commercial_tc_bc_block_experiment_v2';

const getIsAbUseExperimentsActiveFactoryByExperiment = getIsAbUseExperimentsActiveFactory(
  COMMERCIAL_TC_BC_BLOCK_EXPERIMENT,
);

export const isCommercialTCBCBlockExperimentGroupBSelector = createSelector(
  abUseExperimentsSelector,
  getIsAbUseExperimentsActiveFactoryByExperiment('B'),
);
